import { gsap } from 'gsap';
import Flickity from 'flickity';
import ScrollToPlugin from 'gsap/ScrollToPlugin';
import 'flickity-imagesloaded';
import 'flickity-bg-lazyload';
import 'flickity-fade';
import { throttle } from 'lodash';
import './vendor/nlform';

const MOS = {};
window.MOS = MOS;

(() => {
  const SCREENMDMAX = 1199;
  const HEADER_HEIGHT = 100;
  let winSize = 0;
  const calcWinSize = () => {
    winSize = { width: window.innerWidth, height: window.innerHeight };
  };

  const BRAND_MAGENTA = '#EB008B';
  const MAP_DEFAULT_CENTER = { lat: 50.1109, lng: 8.6821 };
  const MAP_BOUNDS_PADDING = {
    top: 60, right: 60, bottom: 60, left: 60,
  };
  const GOOGLE_MAP_DARK_STYLES = [
    { elementType: 'geometry', stylers: [{ color: '#111111' }] },
    { elementType: 'labels.text.fill', stylers: [{ color: '#838383' }] },
    { elementType: 'labels.text.stroke', stylers: [{ color: '#000000' }] },
    { elementType: 'labels.icon', stylers: [{ visibility: 'off' }] },
    {
      featureType: 'administrative',
      elementType: 'geometry',
      stylers: [{ color: '#2c2c2c' }],
    },
    {
      featureType: 'administrative.country',
      elementType: 'geometry.stroke',
      stylers: [{ color: '#2f2f2f' }],
    },
    {
      featureType: 'administrative.land_parcel',
      stylers: [{ visibility: 'off' }],
    },
    {
      featureType: 'landscape',
      elementType: 'geometry.fill',
      stylers: [{ color: '#161616' }],
    },
    {
      featureType: 'poi',
      elementType: 'labels.text.fill',
      stylers: [{ color: '#8d8d8d' }],
    },
    {
      featureType: 'poi',
      elementType: 'labels.text.stroke',
      stylers: [{ color: '#000000' }],
    },
    {
      featureType: 'poi.park',
      elementType: 'geometry',
      stylers: [{ color: '#1e1e1e' }],
    },
    {
      featureType: 'road',
      elementType: 'geometry',
      stylers: [{ color: '#2a2a2a' }],
    },
    {
      featureType: 'road.highway',
      elementType: 'geometry',
      stylers: [{ color: '#3a3a3a' }],
    },
    {
      featureType: 'road.highway',
      elementType: 'geometry.stroke',
      stylers: [{ color: '#1c1c1c' }],
    },
    {
      featureType: 'transit',
      stylers: [{ visibility: 'off' }],
    },
    {
      featureType: 'water',
      elementType: 'geometry',
      stylers: [{ color: '#0b0b0b' }],
    },
    {
      featureType: 'water',
      elementType: 'labels.text.fill',
      stylers: [{ color: '#4d4d4d' }],
    },
  ];
  let googleMapsLoaderPromise = null;

  const loadGoogleMapsApi = (apiKey) => {
    if (typeof window.google !== 'undefined' && window.google.maps) {
      return Promise.resolve(window.google.maps);
    }
    if (googleMapsLoaderPromise) {
      return googleMapsLoaderPromise;
    }
    if (!apiKey) {
      return Promise.reject(new Error('Missing Google Maps API key'));
    }
    googleMapsLoaderPromise = new Promise((resolve, reject) => {
      // eslint-disable-next-line no-underscore-dangle
      window.__GMapInit = () => {
        // eslint-disable-next-line no-underscore-dangle
        delete window.__GMapInit;
        resolve(window.google.maps);
      };
      const script = document.createElement('script');
      script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&callback=__GMapInit`;
      script.async = true;
      script.defer = true;
      script.onerror = (error) => {
        reject(error);
      };
      document.head.appendChild(script);
    }).catch((error) => {
      googleMapsLoaderPromise = null;
      throw error;
    });
    return googleMapsLoaderPromise;
  };

  const scrollTo = (elt, duration, target, offsetY) => {
    console.log('scrollto', elt, duration, target);
    gsap.to(
      window,
      {
        duration: duration || 1,
        scrollTo: (elt.getBoundingClientRect().top + window.scrollY) - (offsetY || 0),
        onComplete: () => {
          if (target !== undefined) {
            // window.location.hash = target;
          }
        },
      },
    );
  };

  class AccordionMenuItem {
    constructor(elt, opts) {
      this.DOM = { elt };
      this.DOM.btn = this.DOM.elt.querySelector('.c-accordion-menu__btn');
      this.DOM.link = this.DOM.elt.querySelector('.c-accordion-menu__link');
      this.DOM.content = this.DOM.elt.querySelector('.c-accordion-menu__content');
      this.isOpen = this.DOM.elt.classList.contains('is-active');
      this.opts = opts;
    }
    toggleCurrent() {
      if (this.isOpen) {
        this.hide();
      } else {
        this.show();
      }
    }
    show() {
      this.toggle('SHOW');
      this.isOpen = true;
    }
    hide() {
      this.toggle('HIDE');
      this.isOpen = false;
    }
    toggle(action) {
      const self = this;
      if (action === 'SHOW') {
        gsap.to(self.DOM.content, { duration: 0.6, height: 'auto' });
        if (self.DOM.btn && self.opts.scrollTo === true) {
          scrollTo(self.DOM.btn, 1, null, HEADER_HEIGHT);
        }
        self.DOM.elt.classList.add('is-active');
      } else {
        gsap.to(self.DOM.content, {
          duration: 0.4,
          height: 0,
          onComplete: () => {
            self.DOM.elt.classList.remove('is-active');
          },
        });
      }
    }
  }
  class AccordionMenu {
    constructor(elt) {
      const self = this;
      self.DOM = { elt };
      self.settings = self.DOM.elt.hasAttribute('data-accordion') ? JSON.parse(self.DOM.elt.getAttribute('data-accordion')) : {};
      self.menuItems = [];
      Array.from(self.DOM.elt.querySelectorAll('.c-accordion-menu__item')).forEach(item => self.menuItems.push(new AccordionMenuItem(item, self.settings)));
      self.init();
      console.log('AccordioMenu::init', self.menuItems.length, self.settings);
    }

    init() {
      this.current = 0;
      this.initEvents();
      if (typeof this.settings !== 'undefined' && 'autoOpen' in this.settings) {
        this.showContent(this.settings.autoOpen);
      }
    }

    initEvents() {
      this.menuItems.forEach((item, pos) => {
        if (item.DOM.btn) {
          item.DOM.btn.addEventListener('click', (e) => {
            e.preventDefault();
            this.showContent(pos);
          });
        }
        if (item.DOM.link) {
          item.DOM.link.addEventListener('click', (e) => {
            e.preventDefault();
            this.showContent(pos);
          });
        }
      });
    }

    showContent(pos) {
      console.log('POS', pos);
      if (typeof this.settings !== 'undefined' && 'autoClose' in this.settings) {
        if (this.current !== pos && this.menuItems[this.current].isOpen) {
          this.menuItems[this.current].hide();
        }
      }
      this.menuItems[pos].toggleCurrent();
      this.current = pos;
    }
  }
  class Carousels {
    constructor(element) {
      if (element.querySelector('.js-carousel')) {
        console.log('Carousels::init', element.querySelectorAll('.js-carousel').length);
        const self = this;
        self.DOM = {
          elts: [],
          eltWrapper: element,
          progressBar: element.querySelector('.c-carousel-progressbar') ? element.querySelector('.c-carousel-progressbar') : undefined,
        };
        element.querySelectorAll('.js-carousel').forEach((elt) => {
          self.DOM.elts.push(elt);
        });
        self.flcks = [];
        self.init();
      }
    }
    init() {
      let idx = 0;
      const self = this;
      self.DOM.elts.forEach((instance) => {
        console.log('Carousels::init', idx);
        const flck = new Flickity(instance);

        if (self.DOM.eltWrapper.querySelector('.btn--next') && self.DOM.eltWrapper.querySelector('.btn--prev')) {
          self.DOM.eltWrapper.querySelector('.btn--next').addEventListener('click', (e) => {
            e.preventDefault();
            flck.next(true, false);
          });
          self.DOM.eltWrapper.querySelector('.btn--prev').addEventListener('click', (e) => {
            e.preventDefault();
            flck.previous(true, false);
          });
        }

        if (self.DOM.progressBar !== undefined) {
          console.log(flck.slides.length);
          flck.slides.forEach(() => {
            const newDiv = document.createElement('div');
            newDiv.style.width = '50%';
            self.DOM.progressBar.appendChild(newDiv);
          });
          flck.on('change', self.onChange.bind(self));
          self.onChange(0);
        }

        if (self.DOM.eltWrapper.querySelector('.c-carousel__info')) {
          self.DOM.infoItem = self.DOM.eltWrapper.querySelector('.c-carousel__info');
          self.DOM.infoItems = self.DOM.eltWrapper.querySelectorAll('.c-carousel__info-item');
          self.DOM.closeBtn = self.DOM.eltWrapper.querySelector('.btn-close');
          flck.on('change', self.onChange.bind(self));
          self.DOM.closeBtn.addEventListener('click', self.onClose.bind(self));
          self.isInfoClosed = false;
          if (winSize.width <= SCREENMDMAX) {
            self.onClose();
          }
        }
        self.flcks.push(flck);
        idx += 1;
      });
    }
    onChange(idx) {
      const self = this;
      if (self.DOM.infoItem) {
        console.log('info', this.DOM.infoItem, this.DOM.infoItems);
        self.DOM.infoItems.forEach((elt, index) => {
          if (index === idx) {
            elt.classList.add('is-active');
          } else {
            elt.classList.remove('is-active');
          }
        });
      }

      if (self.DOM.progressBar) {
        const currIdx = idx + 1;
        self.DOM.progressBar.querySelectorAll('div').forEach((elt) => {
          elt.classList.remove('is-active');
        });
        self.DOM.progressBar.querySelector(`:nth-child(${currIdx})`).classList.add('is-active');
      }
    }

    onClose() {
      const self = this;
      if (self.isInfoClosed) {
        self.DOM.infoItem.classList.add('is-opened');
        self.isInfoClosed = false;
      } else {
        self.DOM.infoItem.classList.remove('is-opened');
        self.isInfoClosed = true;
      }
    }
  }
  class DDMenuItem {
    constructor(elt) {
      this.DOM = { elt };
      this.DOM.btn = this.DOM.elt.querySelector('button');
      this.DOM.backBtn = this.DOM.elt.querySelector('.menu-item__level__back');
      this.DOM.content = this.DOM.elt.querySelector('.menu-item__level');
      this.isOpen = this.DOM.elt.classList.contains('is-active');
      this.init();
    }

    init() {
      const self = this;
      self.DOM.btn.addEventListener('click', self.toggleCurrent.bind(self));
      self.DOM.backBtn.addEventListener('click', self.toggleCurrent.bind(self));
    }

    toggleCurrent() {
      if (this.isOpen) {
        this.hide();
      } else {
        this.show();
      }
    }
    show() {
      this.toggle('SHOW');
      this.isOpen = true;
    }
    hide() {
      this.toggle('HIDE');
      this.isOpen = false;
    }
    toggle(action) {
      if (action === 'SHOW') {
        if (this.DOM.backBtn) {
          gsap.to(this.DOM.content, { autoAlpha: 1, duration: 0.3 });
        } else {
          gsap.to(this.DOM.content, { height: 'auto', duration: 0.3 });
        }
        this.DOM.elt.classList.add('is-active');
      } else {
        if (this.DOM.backBtn) {
          gsap.to(this.DOM.content, { autoAlpha: 0, duration: 0.3 });
        } else {
          gsap.to(this.DOM.content, { height: 0, duration: 0.3 });
        }
        this.DOM.elt.classList.remove('is-active');
      }
    }
  }
  class SideNav {
    constructor(elt, eltWrapper) {
      if (document.querySelector(elt) && document.querySelector(eltWrapper)) {
        const self = this;
        self.DOM = { elt: document.querySelector(elt) };
        self.DOM.eltWrapper = document.querySelector(eltWrapper);
        self.settings = self.DOM.elt.hasAttribute('data-settings') ? JSON.parse(self.DOM.elt.getAttribute('data-settings')) : {};
        self.DOM.openBtn = self.DOM.eltWrapper.querySelector('.btn-burger');
        self.isOpen = false;
        self.initEvents();
      }
    }
    initEvents() {
      console.log('SideNav::initEvents');
      const self = this;
      self.DOM.openBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (this.isOpen) {
          this.toggle('close');
        } else {
          this.toggle('open');
        }
      });
      self.menuItems = [];
      Array.from(self.DOM.elt.querySelectorAll('.menu__item--ddm')).forEach((item) => { console.log('item', item); this.menuItems.push(new DDMenuItem(item)); });
    }

    toggle(action, _self) {
      const self = _self || this;
      self.isOpen = action === 'open';

      if (self.isOpen) {
        self.DOM.elt.classList.add('is-open');
        self.DOM.openBtn.classList.add('is-active');
      } else {
        self.DOM.elt.classList.remove('is-open');
        self.DOM.openBtn.classList.remove('is-active');
      }
    }
  }

  class MainNav {
    constructor(elt, eltWrapper) {
      const self = this;
      if (document.querySelector(elt) && document.querySelector(eltWrapper)) {
        self.DOM = { elt: document.querySelector(elt) };
        self.DOM.eltWrapper = document.querySelector(eltWrapper);
        self.settings = self.DOM.elt.hasAttribute('data-settings') ? JSON.parse(self.DOM.elt.getAttribute('data-settings')) : {};
        self.DOM.toggleBtn = document.querySelector('.btn-burger');
        self.DOM.closeBtn = self.DOM.eltWrapper.querySelector('.btn-close');
        self.isOpen = false;
        self.initEvents();
      }
    }

    initEvents() {
      console.log('MainNav::initEvents');
      const self = this;
      self.DOM.toggleBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (self.isOpen) {
          self.toggle('close');
          document.querySelector('body').classList.remove('is-open');
        } else {
          self.toggle('open');
          document.querySelector('body').classList.add('is-open');
        }
      });

      if (self.DOM.closeBtn) {
        self.DOM.closeBtn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.toggle('close');
        });
      }

      self.menuItems = [];
      Array.from(self.DOM.elt.querySelectorAll('.menu__item--ddm')).forEach((item) => {
        self.menuItems.push(new DDMenuItem(item));
      });

      if (self.settings.sticky !== undefined && self.settings.sticky
        && winSize.width > SCREENMDMAX) {
        window.addEventListener('scroll', throttle(self.onScroll.bind(self), 500, { leading: true, trailing: true }));
      }
    }

    open() {
      this.DOM.elt.classList.add('is-open');
      this.DOM.toggleBtn.classList.add('is-active');
      this.isOpen = true;
    }

    close() {
      this.DOM.elt.classList.remove('is-open');
      this.DOM.toggleBtn.classList.remove('is-active');
      this.isOpen = false;
    }

    toggle(action, _self) {
      const self = _self || this;
      self.isOpen = action === 'open';

      if (self.isOpen) {
        self.open();
      } else {
        self.close();
      }
    }

    onScroll() {
      const windowScrollY = window.scrollY;
      if (windowScrollY > 50) {
        this.DOM.elt.classList.add('is-sticky');
        this.DOM.isSticky = true;
      } else {
        this.DOM.elt.classList.remove('is-sticky');
        this.DOM.isSticky = false;
      }
      // console.log('StickyNav::scrolling', windowScrollY);
    }
  }
  class Header {
    constructor(elt) {
      const self = this;
      if (document.querySelector(elt)) {
        self.DOM = { elt: document.querySelector(elt) };
        self.settings = self.DOM.elt.hasAttribute('data-settings') ? JSON.parse(self.DOM.elt.getAttribute('data-settings')) : {};
        self.initEvents();
      }
    }

    initEvents() {
      console.log('Header::initEvents');
      const self = this;
      window.addEventListener('scroll', throttle(self.onScroll.bind(self), 500, { leading: true, trailing: true }));
    }

    onScroll() {
      const windowScrollY = window.scrollY;
      if (windowScrollY > 50) {
        this.DOM.elt.classList.add('is-sticky');
        this.DOM.isSticky = true;
      } else {
        this.DOM.elt.classList.remove('is-sticky');
        this.DOM.isSticky = false;
      }
      // console.log('StickyNav::scrolling', windowScrollY);
    }
  }

  class SearchPanel {
    constructor(elt) {
      const self = this;
      if (document.querySelector(elt)) {
        self.DOM = { elt: document.querySelector(elt) };
        self.DOM.openBtn = document.querySelector('#btn-search');
        self.DOM.closeBtn = self.DOM.elt.querySelector('.search-panel__close');
        self.isOpen = self.DOM.elt.classList.contains('is-open');
        self.initEvents();
      }
    }

    initEvents() {
      console.log('SearchPanel::initEvents');
      const self = this;

      if (self.DOM.openBtn) {
        self.DOM.openBtn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          if (self.isOpen) {
            self.toggle('close');
          } else {
            self.toggle('open');
          }
        });
      }

      if (self.DOM.closeBtn) {
        self.DOM.closeBtn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          self.toggle('close');
        });
      }

      // Close on Escape key
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && self.isOpen) {
          self.toggle('close');
        }
      });

      // Handle checkbox interactions
      const allPagesCheckbox = self.DOM.elt.querySelector('#pages-all');
      const filterCheckboxes = self.DOM.elt.querySelectorAll('.search-panel__filters input[type="checkbox"]:not(#pages-all)');

      if (allPagesCheckbox && filterCheckboxes.length > 0) {
        // Helper function to check if all filter checkboxes are unchecked
        const checkIfAllUnchecked = () => {
          const allUnchecked = Array.from(filterCheckboxes).every(checkbox => !checkbox.checked);
          if (allUnchecked && !allPagesCheckbox.checked) {
            allPagesCheckbox.checked = true;
          }
        };

        // When any filter checkbox is checked, uncheck "All Pages"
        // When any filter checkbox is unchecked, check if all are unchecked
        filterCheckboxes.forEach((checkbox) => {
          checkbox.addEventListener('change', (e) => {
            if (e.target.checked && allPagesCheckbox.checked) {
              allPagesCheckbox.checked = false;
            } else if (!e.target.checked) {
              checkIfAllUnchecked();
            }
          });
        });

        // When "All Pages" is checked, uncheck all other filters
        allPagesCheckbox.addEventListener('change', (e) => {
          if (e.target.checked) {
            filterCheckboxes.forEach((checkbox) => {
              checkbox.checked = false;
            });
          }
        });
      }
    }

    open() {
      this.DOM.elt.classList.add('is-open');
      this.isOpen = true;
      document.querySelector('body').classList.add('search-panel-open');
    }

    close() {
      this.DOM.elt.classList.remove('is-open');
      this.isOpen = false;
      document.querySelector('body').classList.remove('search-panel-open');
    }

    toggle(action) {
      if (action === 'open') {
        this.open();
      } else {
        this.close();
      }
    }
  }

  class GMap {
    constructor(wrapper) {
      this.wrapper = wrapper;
      this.canvas = wrapper.querySelector('[data-gmap-canvas]');
      this.infoPanel = wrapper.querySelector('[data-gmap-info]');
      this.statusEl = wrapper.querySelector('[data-gmap-status]');
      this.nameEl = wrapper.querySelector('[data-location-name]');
      this.descriptionEl = wrapper.querySelector('[data-location-description]');
      this.addressEl = wrapper.querySelector('[data-location-address]');
      this.phoneEl = wrapper.querySelector('[data-location-phone]');
      this.emailEl = wrapper.querySelector('[data-location-email]');
      this.ctaEl = wrapper.querySelector('[data-location-cta]');
      this.locations = this.parseLocations();
      this.apiKey = this.getApiKey();
      this.markers = [];
      this.activeMarker = null;

      if (!this.canvas || this.locations.length === 0) {
        this.setStatus('Map data unavailable.', true);
        this.wrapper.classList.add('c-gmap--error');
        return;
      }

      if (!this.apiKey) {
        this.setStatus('Provide a Google Maps API key to enable this map.', true);
        this.wrapper.classList.add('c-gmap--error');
        return;
      }

      this.wrapper.classList.add('is-loading');
      this.setStatus('Loading interactive map…');
      this.init();
    }

    getApiKey() {
      const { body } = document;
      const { documentElement: root } = document;
      return this.wrapper.getAttribute('data-gmap-api-key')
        || (body && body.getAttribute('data-gmap-api-key'))
        || (root && root.getAttribute('data-gmap-api-key'))
        || window.GOOGLE_MAPS_API_KEY
        || window.GMAPS_API_KEY
        || window.MAPS_API_KEY
        || '';
    }

    parseLocations() {
      const dataEl = this.wrapper.querySelector('.c-gmap__data');
      if (!dataEl || !dataEl.textContent) {
        return [];
      }
      try {
        return JSON.parse(dataEl.textContent);
      } catch (error) {
        console.warn('GMap::parseLocations', error);
        return [];
      }
    }

    init() {
      loadGoogleMapsApi(this.apiKey)
        .then((maps) => {
          this.maps = maps;
          this.buildMap();
          this.setStatus('');
          this.wrapper.classList.remove('is-loading');
        })
        .catch((error) => {
          console.warn('GMap::init', error);
          this.setStatus('Interactive map unavailable right now.', true);
          this.wrapper.classList.add('c-gmap--error');
          this.wrapper.classList.remove('is-loading');
        });
    }

    buildMap() {
      const firstLocation = this.locations[0];
      const initialCenter = firstLocation
        ? { lat: firstLocation.lat, lng: firstLocation.lng }
        : MAP_DEFAULT_CENTER;
      this.markerIcons = {
        default: this.buildMarkerIcon(30),
        active: this.buildMarkerIcon(38),
      };
      this.map = new this.maps.Map(this.canvas, {
        center: initialCenter,
        zoom: 4,
        minZoom: 3,
        disableDefaultUI: true,
        zoomControl: true,
        styles: GOOGLE_MAP_DARK_STYLES,
        gestureHandling: 'greedy',
        backgroundColor: '#000000',
      });
      this.bounds = new this.maps.LatLngBounds();
      this.locations.forEach((location) => {
        this.createMarker(location);
      });
      if (this.locations.length > 1 && this.bounds && !this.bounds.isEmpty()) {
        this.map.fitBounds(this.bounds, MAP_BOUNDS_PADDING);
      } else if (firstLocation) {
        this.map.setCenter(initialCenter);
        this.map.setZoom(5);
      }
      if (this.markers[0]) {
        this.activateMarker(this.markers[0], false);
      } else {
        this.updateInfoPanel(null);
      }
      this.wrapper.classList.remove('c-gmap--error');
    }

    createMarker(location) {
      if (!location || typeof location.lat !== 'number' || typeof location.lng !== 'number') {
        return;
      }
      const marker = new this.maps.Marker({
        map: this.map,
        position: { lat: location.lat, lng: location.lng },
        title: location.name,
        icon: this.markerIcons.default,
        optimized: true,
      });
      marker.officeLocation = { location };
      if (this.bounds) {
        this.bounds.extend(marker.getPosition());
      }
      marker.addListener('click', () => {
        this.activateMarker(marker);
      });
      this.markers.push(marker);
    }

    activateMarker(marker, shouldPan) {
      if (!marker) {
        return;
      }
      if (this.activeMarker && this.activeMarker !== marker) {
        this.activeMarker.setIcon(this.markerIcons.default);
      }
      marker.setIcon(this.markerIcons.active);
      this.activeMarker = marker;
      this.updateInfoPanel(marker.officeLocation.location);
      if (shouldPan !== false && marker.getPosition && this.map) {
        this.map.panTo(marker.getPosition());
      }
    }

    updateInfoPanel(location) {
      if (!this.infoPanel) {
        return;
      }
      if (!location) {
        if (this.nameEl) {
          this.nameEl.textContent = 'Choose a location';
        }
        if (this.descriptionEl) {
          this.descriptionEl.textContent = 'Tap a magenta pin to reveal details about that AIPEX office.';
        }
        if (this.addressEl) {
          this.addressEl.innerHTML = '';
        }
        if (this.phoneEl) {
          this.phoneEl.textContent = '';
        }
        if (this.emailEl) {
          this.emailEl.textContent = 'hello@wynne-jones.com';
          this.emailEl.setAttribute('href', 'mailto:hello@wynne-jones.com');
        }
        if (this.ctaEl) {
          this.ctaEl.setAttribute('href', 'mailto:hello@wynne-jones.com');
        }
        return;
      }
      if (this.nameEl) {
        this.nameEl.textContent = location.name || '';
      }
      if (this.descriptionEl) {
        this.descriptionEl.textContent = location.description || '';
      }
      if (this.addressEl) {
        this.addressEl.innerHTML = Array.isArray(location.address)
          ? location.address.map(line => `<span>${line}</span>`).join('<br>')
          : '';
      }
      if (this.phoneEl) {
        this.phoneEl.textContent = location.phone || '';
      }
      if (this.emailEl) {
        const email = location.email || 'hello@wynne-jones.com';
        this.emailEl.textContent = email;
        this.emailEl.setAttribute('href', `mailto:${email}`);
      }
      if (this.ctaEl) {
        const ctaHref = location.cta || (location.email ? `mailto:${location.email}` : '#');
        this.ctaEl.setAttribute('href', ctaHref);
        if (ctaHref === '#') {
          this.ctaEl.setAttribute('aria-disabled', 'true');
        } else {
          this.ctaEl.removeAttribute('aria-disabled');
        }
      }
    }

    setStatus(message, isError) {
      if (!this.statusEl) {
        return;
      }
      this.statusEl.textContent = message || '';
      if (message) {
        this.statusEl.classList.toggle('is-error', !!isError);
      } else {
        this.statusEl.classList.remove('is-error');
      }
    }

    buildMarkerIcon(size) {
      if (!this.maps) {
        return null;
      }
      const height = Math.round(size * (44 / 28));
      const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="28" height="44" viewBox="0 0 28 44" fill="none"><path d="M14 0C7.37258 0 2 5.37258 2 12C2 21 14 44 14 44C14 44 26 21 26 12C26 5.37258 20.6274 0 14 0Z" fill="${BRAND_MAGENTA}"/><circle cx="14" cy="13" r="5" fill="#0B0B0B"/></svg>`;
      return {
        url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`,
        scaledSize: new this.maps.Size(size, height),
        anchor: new this.maps.Point(size / 2, height - 4),
      };
    }
  }

  class FileUpload {
    constructor() {
      this.init();
    }

    init() {
      this.fileInputs = document.querySelectorAll('.inputfile[type="file"]');
      this.fileInputs.forEach((input) => {
        const wrapper = input.closest('.fileupload__wrapper');
        if (!wrapper) return;

        const displayField = wrapper.querySelector('.fileupload__display');
        if (!displayField) return;

        // Handle file selection
        input.addEventListener('change', (e) => {
          FileUpload.handleFileChange(e, displayField);
        });

        // Handle display field click to trigger file input
        displayField.addEventListener('click', () => {
          input.click();
        });
      });
    }

    static handleFileChange(e, displayField) {
      const { target: { files } } = e;
      const hasFiles = files && files.length > 0;

      if (hasFiles) {
        const fileNames = Array.from(files).map(file => file.name).join(', ');
        displayField.value = fileNames;
        displayField.classList.add('has-file');
      } else {
        displayField.value = '';
        displayField.classList.remove('has-file');
      }
    }
  }

  function initRedicationSpans() {
    const redicationElements = document.querySelectorAll('.redication');
    redicationElements.forEach((element) => {
      // Check if empty span already exists to avoid duplicates
      if (!element.querySelector('span')) {
        const emptySpan = document.createElement('span');
        element.appendChild(emptySpan);
      }
    });
  }

  function init() {
    MOS.sideNav = new SideNav('.c-main-nav[data-menu-style="sidenav"]', '.c-main-nav__wrapper');
    MOS.mainNav = new MainNav('.c-main-nav', '.c-main-nav__wrapper');
    MOS.header = new Header('.main-header[data-menu-type="sticky"]');
    MOS.searchPanel = new SearchPanel('.search-panel');
    MOS.searchSidebar = new SearchPanel('.search-sidebar');
    MOS.fileUpload = new FileUpload();
    initRedicationSpans();

    if (document.querySelectorAll('.c-accordion-menu')) {
      MOS.accordionMenu = [];
      document.querySelectorAll('.c-accordion-menu').forEach((element) => {
        MOS.accordionMenu.push(new AccordionMenu(element));
      });
    }

    if (document.querySelector('.js-carousel-wrapper')) {
      MOS.carousels = [];
      document.querySelectorAll('.js-carousel-wrapper').forEach((element) => {
        MOS.carousels.push(new Carousels(element));
      });
    }

    if (document.querySelector('.c-gmap')) {
      MOS.GMaps = [];
      document.querySelectorAll('.c-gmap').forEach((element) => {
        MOS.GMaps.push(new GMap(element));
      });
    }

    document.querySelectorAll('.readmore > .btn').forEach((element) => {
      element.addEventListener('click', (e) => {
        e.preventDefault();
        element.parentElement.classList.add('active');
      });
    });
  }

  MOS.Util = {
    hasTouchScreen: () => {
      let hasTouch = false;
      if ('ontouchstart' in window) {
        hasTouch = true;
      } else if ('maxTouchPoints' in navigator) {
        hasTouch = navigator.maxTouchPoints >= 1 && navigator.maxTouchPoints <= 10;
      } else if ('msMaxTouchPoints' in navigator) {
        hasTouch = navigator.msMaxTouchPoints > 0;
      } else {
        const mQ = window.matchMedia && matchMedia('(pointer:coarse)');
        if (mQ && mQ.media === '(pointer:coarse)') {
          hasTouch = !!mQ.matches;
        } else if ('orientation' in window) {
          hasTouch = true; // deprecated, but good fallback
        } else {
          // Only as a last resort, fall back to user agent sniffing
          const UA = navigator.userAgent;
          hasTouch = (
            /\b(BlackBerry|webOS|iPhone|IEMobile)\b/i.test(UA) ||
            /\b(Android|Windows Phone|iPad|iPod)\b/i.test(UA)
          );
        }
      }
      return hasTouch;
    },
  };
  document.addEventListener('DOMContentLoaded', () => {
    gsap.registerPlugin(ScrollToPlugin);
    calcWinSize();
    init();
  });
})();
